module.exports = __webpack_public_path__ + "img/arrow-left-short.36456acd.svg";